document.addEventListener("DOMContentLoaded", () => {

  const collection_tabs = document.querySelectorAll(".Index_featured_collection_tab");
  const collection_details = document.querySelectorAll(".Index_tab_featured_collection_details");

  if (!collection_tabs.length) return;

  // Show first tab BEFORE Swiper init
  collection_tabs[0].classList.add("active");
  const firstHandle = collection_tabs[0].dataset.collectionTab;
  collection_details.forEach(detail => {
    if (detail.dataset.collection === firstHandle) detail.classList.add("show");
  });

  // Init each Swiper individually
  const swipers = {};
  document.querySelectorAll(".Index_tab_featured_collection_slider").forEach(el => {
    const handle = el.dataset.collection;
    if (!handle) return;
    swipers[handle] = new Swiper(el, {
      slidesPerView: 3,
      direction: "horizontal",
      observer: true,
      observeParents: true,
      mousewheel: { forceToAxis: true },
      breakpoints: {
        0:    { slidesPerView: 1.335, spaceBetween: 17 },
        750: { slidesPerView: 2, spaceBetween: 17 },
        990:  { slidesPerView: 3, spaceBetween: 24 },
        1440: { spaceBetween: 28 }
      }
    });
  });

  // Tab click
  collection_tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      collection_tabs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");

      const tabsContainer = this.closest(".Index_featured_collection_tabs");
      if (tabsContainer) {
        const scrollTo = this.offsetLeft - (tabsContainer.offsetWidth / 2) + (this.offsetWidth / 2);
        tabsContainer.scrollTo({ left: scrollTo, behavior: "smooth" });
      }
      // this.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });

      const handle = this.dataset.collectionTab;

      collection_details.forEach(detail => {
        if (detail.dataset.collection === handle) {
          detail.classList.add("show");
          // Wait for browser to paint before updating Swiper
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              if (swipers[handle]) swipers[handle].update();
            });
          });
        } else {
          detail.classList.remove("show");
        }
      });
    });
  });
});
